@if (displayTimer) {
  <h2 mat-dialog-title>Session Timeout</h2>
}
@if (displayTimer) {
  <div mat-dialog-content>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h4>
            Session will expire in <strong style="color: red">{{ displayTimer }} Seconds</strong>
          </h4>
          <p>Click "Resume Session" to "Continue" or "Logout" to end the session</p>
        </div>
      </div>
    </div>
  </div>
}
@if (displayTimer) {
  <div mat-dialog-actions align="end">
    <button
      mat-button
      role="button"
      type="button"
      aria-label="Resume"
      cdkFocusInitial
      (click)="resume()"
    >
      Resume session
    </button>
    <button mat-button role="button" type="button" aria-label="Logout" (click)="logout()">
      Logout
    </button>
  </div>
}
